import { FormattedMessage } from 'react-intl'

export const YesNo = ({ truthy }: { truthy: boolean }) => <FormattedMessage id={truthy ? 'yes' : 'no'} />

export const YesNoIncomplete = ({ truthy }: { truthy: boolean | null }) => (
  <FormattedMessage id={truthy === null ? 'incomplete' : truthy ? 'yes' : 'no'} />
)
